//--------------------------------------------------------------------//
//******************** agentGroupsTab ********************************//
//--------------------------------------------------------------------//
// Manages which gudhub permission groups an agent belongs to. Lists
// assigned groups in a table with a delete action, and lets the user
// pick from their own groups (not yet assigned) to add the agent to.
import agentGroupsTemplateUrl from './agent-groups.template.html';

angular.module('agentsTableModule')

.directive('agentGroupsTab', ['GhDialog', function (GhDialog) {
    return {
        restrict: 'E',
        scope: {
            agent: '='
        },
        controller: ['$scope', 'localizationService', function ($scope, localizationService) {
            const dictionary = localizationService.getDictionary('account_settings');
            $scope.translate = (word) => localizationService.translate(word, dictionary);
            const translate = $scope.translate;

            $scope.options = [{
                name: translate('Blocked'),
                value: 0,
                color: '#000000'
            }, {
                name: translate('Member'),
                value: 1,
                color: '#05B52C'
            }, {
                name: translate('Admin'),
                value: 2,
                color: '#0FB5FF'
            }];

            $scope.assignedGroups = [];
            $scope.availableGroups = [];
            $scope.showInput = false;
            $scope.selectedGroupId = '';

            const agentUserId = $scope.agent.gudhub_user_id;

            // Fetches the groups the agent (as a gudhub user) belongs to, and the current user's
            // own groups (filtered to Admin/Owner) to populate the add-dropdown.
            async function loadGroups() {
                if (!agentUserId) return;
                try {
                    const myUserId = gudhub.storage.getUser().user_id;
                    const [assigned, myGroups] = await Promise.all([
                        gudhub.groupSharing.getGroupsByUser(agentUserId),
                        gudhub.groupSharing.getGroupsByUser(myUserId)
                    ]);

                    $scope.assignedGroups = assigned || [];
                    $scope.availableGroups = (myGroups || [])
                        .filter(g => g.group_permission == 2 || g.group_permission == 3)
                        .filter(g => !$scope.assignedGroups.some(a => a.group_id === g.group_id))
                        .map(g => ({ name: g.group_name, value: g.group_id }));

                    $scope.$applyAsync();
                } catch (err) {
                    console.error('Failed to load groups:', err);
                }
            }
            loadGroups();

            // Adds the agent as a member of the selected group, defaulting to "Member" (1).
            $scope.$watch('selectedGroupId', async function (newVal, oldVal) {
                if (newVal && oldVal !== newVal) {
                    $scope.selectedGroupId = '';
                    try {
                        await gudhub.groupSharing.addUserToGroup(newVal, agentUserId, 1);
                        $scope.showInput = false;
                        await loadGroups();
                    } catch (err) {
                        console.error('Failed to add agent to group:', err);
                    }
                }
            });

            // Removes the agent's membership from a group.
            async function removeGroupMembership(group) {
                try {
                    await gudhub.groupSharing.deleteUserFromGroup(agentUserId, group.group_id);
                    await loadGroups();
                } catch (err) {
                    console.error('Failed to remove agent from group:', err);
                }
            }

            // Opens a confirmation dialog before removing the agent from a group.
            $scope.removeGroup = function (group) {
                GhDialog.show({
                    position: 'center',
                    toolbar: false,
                    template: {
                        toolbar: '',
                        resizable: false,
                        content: `
                            <div class="delete_agent-popup">
                                <div class="dialog-share-group">
                                    <span gh-icon="rubbish FF0D0D 65px"></span>
                                    <p class="dialog-share-group__title">{{translate('Removing From Group!')}}</p>
                                </div>

                                <div class="dialog-share-group__content">
                                    <p class="info">
                                        {{translate('Do you really want to remove this agent from')}} "{{group.group_name}}"?
                                    </p>

                                    <div class="dialog-share-group__content__buttons">
                                        <button
                                            class="dialog-share-group__content__buttons__add btn btn-blue-reverse"
                                            ng-click="confirmRemove()"
                                        >
                                            {{translate('Remove')}}
                                        </button>

                                        <button
                                            class="dialog-share-group__content__buttons__cancel btn btn-blue"
                                            ng-click="cancel()"
                                        >
                                            {{translate('Cancel')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        `
                    },
                    locals: {
                        group
                    },
                    controller: ['$scope', 'group', 'localizationService', function ($dialogScope, group, localizationService) {
                        const dialogDictionary = localizationService.getDictionary('account_settings');
                        $dialogScope.translate = (word) => localizationService.translate(word, dialogDictionary);
                        $dialogScope.group = group;

                        $dialogScope.confirmRemove = function () {
                            removeGroupMembership(group);
                            $dialogScope.cancel();
                        };
                    }]
                });
            };

            // Updates the agent's membership level within a group (Blocked/Member/Admin).
            $scope.updateGroupPermission = async function (value, group) {
                try {
                    await gudhub.groupSharing.updateUserInGroup(agentUserId, group.group_id, value);
                } catch (err) {
                    console.error('Failed to update agent membership:', err);
                }
            };
        }],
        templateUrl: agentGroupsTemplateUrl
    };
}]);
